import { createSlice, type PayloadAction } from '@reduxjs/toolkit';

import type { ModalType } from './types';

export interface ModalState {
  activeModal: ModalType | null;
}

const initialState: ModalState = {
  activeModal: null,
};

const modalsSlice = createSlice({
  name: 'modals',
  initialState,
  reducers: {
    changeActiveModal: (state, action: PayloadAction<ModalType | null>) => {
      state.activeModal = action.payload;
      if (action.payload === null) {
        state.activeModal = null;
      }
    },
  }
});

export const selectActiveModal = (state: RootState) => state.modals.activeModal;

export const { changeActiveModal } = modalsSlice.actions;
export { modalsSlice };
